import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const SummaryCard = styled.section`
  border-radius: 8px;
  border: 1px solid ${ColorPalette.HEX.BrightGray};
  background-color: ${ColorPalette.HEX.White};
  padding: 36px 32px;

  @media ${({ theme }) => theme.device.desktop} {
    margin: 0;
    display: grid;
    row-gap: 60px;
    column-gap: 120px;
    grid-template-columns: 1fr 1fr;
  }
`;

export const SummaryTitle = styled.h5`
  font-weight: bold;
  color: ${({ theme }) => theme.travelReport.color};
`;

export const SummarySubtitle = styled.span`
  font-size: 14px;
  margin-bottom: 45px;
`;

export const Divider = styled.div`
  height: 1px;
  border-bottom: solid 1px ${({ theme }) => theme.group.division};
`;

export const ReportSummaryContainer: any = styled.div`
  padding: 20px 16px;

  @media ${({ theme }) => theme.device.desktop} {
    padding: 0;
    min-height: 0;
  }
`;
